import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { LoadingController, ModalController, ToastController } from '@ionic/angular';
import { Storage } from '@ionic/storage-angular';
import { ChatMdlPage } from 'src/app/pages/chat-mdl/chat-mdl.page';
import { MdlBandejaAgentePage } from 'src/app/pages/mdl-bandeja-agente/mdl-bandeja-agente.page';
import { MdlFiltroPage } from 'src/app/pages/mdl-filtro/mdl-filtro.page';
import { ModalCalidadPage } from 'src/app/pages/modal-calidad/modal-calidad.page';
import { ModalConversacionPage } from 'src/app/pages/modal-conversacion/modal-conversacion.page';
import { ChatService } from 'src/app/services/chat.service';
import { WhatsappService } from 'src/app/services/whatsapp.service';
import { ValidarToken } from 'src/app/validators/valida-datos';

@Component({
  selector: 'app-reportes-chats',
  templateUrl: './reportes-chats.component.html',
  styleUrls: ['./reportes-chats.component.scss'],
})
export class ReportesChatsComponent implements OnInit {

  idAdmin: any;
  vista: number;
  fechaInicial: any;
  fechaFinal: any;
  loading: any;
  conversaciones: any;
  arrConver: any;
  classUser: any;
  searchReporte: string;
  pagina: number;
  paginacion: number;
  totalPag: number;
  dataFiltro: any;
  tel = new FormControl('');
  agente = new FormControl('');
  resultado = new FormControl('');
  origen = new FormControl('');
  idStatus: any;
  descarga: boolean;
  registros: number;
  arrFiltro: any;
  totalFiltro: number;
  banderaNum: boolean;
  bloqueo: string;
  desBloqueo: string;
  mostrarCalidad: boolean;

  canal: any;
  canales: any;
  canalInicial: any;

  seeFromPc: boolean;

  constructor(
    private storage: Storage,
    private serviceWa: WhatsappService,
    private chatService: ChatService,
    private loadingController: LoadingController,
    private toastCtrl: ToastController,
    private modalCtrl: ModalController,
    private formatdate: DatePipe,
  ) {
    this.canales = [];
    this.banderaNum = true;
    this.descarga = false;
    this.fechaFinal = new FormControl('');
    this.fechaInicial = new FormControl('');
    this.pagina = 1;
    this.paginacion = 0;
    this.totalFiltro = 0;
    this.conversaciones = [];
    this.desBloqueo = 'lock-closed-outline';
    this.bloqueo = 'lock-open-outline';
    this.dataFiltro = {
      agente: [],
      numero: '',
      resultado: [],
      origen: [],
      equipo: [],
      estado: [],
    };
    this.arrFiltro = {
      estado: [],
      agentes: [],
      resultados: [],
      origen: [],
      equipo: []
    };
    this.mostrarCalidad = false;
  }

  ngOnInit() {
    // this.getStorage();
    setTimeout(() => {
      this.getCanal();
      // this.consulta(0, 0);
    }, 200);
    this.vista = 1;
    this.conversaciones = [];
    this.arrConver = [];
  }

  async getStorage() {
    const usuario = await this.storage.get('usuario');
    // this.idAdmin = usuario.idAdmin;
    // console.log(this.idAdmin);
  }

  async getCanal() {
    this.canal = await this.storage.get('canal').then();
    this.canales = await this.storage.get('canales').then();
    // console.log(this.canales, 'canales ');
    this.canalInicial = this.canales.find(canal => canal.canale.idAdmin_sec == this.canal.idAdmin_sec);
    this.idAdmin = this.canalInicial.canale.idAdmin_sec;
    this.classUser = this.canalInicial;
    this.isPC(this.idAdmin);
    // console.log(this.canal.url_back, 'url de back desde storage');
  }

  consulta2(val, tipoConsulta) {
    // console.log('Entra consulta');
    let pag = this.paginacion;
    let des = 0;
    if (tipoConsulta == 1) {
      pag = 0;
      this.pagina = 1;
    }
    if (this.descarga) {
      pag = 0;
      des = 1;
      this.dataFiltro.nombre = `Reporte-Conversaciones-${this.formatdate.transform(new Date(), 'dd-MM-yyyy-HH-mm-ss')}`;
      // this.loading.dismiss();
    }
    if (!this.descarga) {
      this.presentLoading('Cargando conversaciones...');
      // this.loading.dismiss();
    }
    // console.log(this.dataFiltro);
    let query =
      `admin=${this.idAdmin}${this.dataFiltro.numero}&descarga=${des}`;
    if (val > 0) {
      let feIn = new Date(this.fechaInicial.value);
      let feFin = new Date(this.fechaFinal.value);

      if (val === 2) {
        feIn = this.fechaInicial.value;
        feFin = this.fechaFinal.value;
      }
      feIn.toUTCString();
      feFin.toUTCString();
      const dayIn = feIn.getUTCDate();
      const dayFin = feFin.getUTCDate();
      if (val === 2) {
        feIn.setUTCDate(dayIn);
        feFin.setUTCDate(dayFin);
      } else {
        feIn.setUTCDate(dayIn + 1);
        feFin.setUTCDate(dayFin + 1);
      }
      feIn.setHours(0, 0, 0);
      feFin.setHours(23, 59, 59);
      // console.log(feIn);
      // console.log(feFin);
      query = `admin=${this.idAdmin}&inicio=${feIn}&fin=${feFin}${this.dataFiltro.numero}&descarga=${des}`;
    }
    // console.log(query, pag, this.dataFiltro);
    this.serviceWa.getHistorialConver(query, this.classUser.id, this.classUser.rol, this.classUser.token, pag, this.dataFiltro, this.classUser.canale.url_back).subscribe(
      async (res: any) => {
        console.log(res, 'Reporte de chats');
        if (des === 0) {
          await this.loading.dismiss();
        }

        const { status, message } = res;
        if (status === 'success') {
          const { reportes, registros } = res;
          this.registros = registros;
          this.totalPag = Math.round(this.registros / 30);
          if (this.registros <= 30) {
            this.totalPag = 1;
          }

          if (des === 0) {
            this.conversaciones = reportes;
            // console.log(this.conversaciones,'conversaciones');
            this.formatTable(this.conversaciones);
          }
          //  this.conversaciones.forEach(element => {
          //   element.conversacion.createdAt = new Date(element.conversacion.createdAt);
          //  });
          //  console.log(this.conversaciones);
          if (des === 0) {
            await this.loading.dismiss();
            this.presentToast('Datos encontrados!', 'success');
          }

          this.vista = 1;
        }
        else {
          if (!this.descarga) {
            await this.loading.dismiss();
            this.presentToast('No se encontrarón conversaciones', 'danger');
          }
        }
      },
      erro => {
        console.log(erro);
        if (!this.descarga) {
          this.loading.dismiss();
        }
      });

  }

  consulta(val, tipoConsulta) {
    // console.log('Entra consulta');
    let pag = this.paginacion;
    let des = 0;
    if (tipoConsulta == 1) {
      pag = 0;
      this.pagina = 1;
    }
    if (this.descarga) {
      pag = 0;
      des = 1;
      this.dataFiltro.nombre = `Reporte-Conversaciones-${this.formatdate.transform(new Date(), 'dd-MM-yyyy-HH-mm-ss')}`;
      // this.loading.dismiss();
    }
    if (!this.descarga) {
      this.presentLoading('Cargando conversaciones...');
      // this.loading.dismiss();
    }
    // console.log(this.dataFiltro);
    let query =
      `admin=${this.idAdmin}${this.dataFiltro.numero}&descarga=${des}`;
    if (val > 0) {
      let feIn = new Date(this.fechaInicial.value);
      let feFin = new Date(this.fechaFinal.value);

      if (val === 2) {
        feIn = this.fechaInicial.value;
        feFin = this.fechaFinal.value;
      }
      feIn.toUTCString();
      feFin.toUTCString();
      const dayIn = feIn.getUTCDate();
      const dayFin = feFin.getUTCDate();
      if (val === 2) {
        feIn.setUTCDate(dayIn);
        feFin.setUTCDate(dayFin);
      } else {
        feIn.setUTCDate(dayIn + 1);
        feFin.setUTCDate(dayFin + 1);
      }
      feIn.setHours(0, 0, 0);
      feFin.setHours(23, 59, 59);
      console.log(feIn);
      console.log(feFin);
      query = `admin=${this.idAdmin}&inicio=${feIn}&fin=${feFin}${this.dataFiltro.numero}&descarga=${des}`;
    }
    // console.log(query, pag, this.dataFiltro);
    this.serviceWa.getHistorialConverOptimo(query, this.classUser.id, this.classUser.rol, this.classUser.token, pag, this.dataFiltro, this.classUser.canale.url_back).subscribe(
      async (res: any) => {
        console.log(res, 'Reporte de chats');
        if (des === 0) {
          await this.loading.dismiss();
        }

        const { status, message } = res;
        if (status === 'success') {
          const { reportes, registros } = res;
          this.registros = registros;
          this.totalPag = Math.round(this.registros / 30);
          if (this.registros <= 30) {
            this.totalPag = 1;
          }
          if (des === 0) {
            this.conversaciones = reportes;
            // console.log(this.conversaciones,'conversaciones');
            this.formatTable(this.conversaciones);
          }
          //  this.conversaciones.forEach(element => {
          //   element.conversacion.createdAt = new Date(element.conversacion.createdAt);
          //  });
          //  console.log(this.conversaciones);
          if (des === 0) {
            await this.loading.dismiss();
            this.presentToast('Datos encontrados!', 'success');
          }

          this.vista = 1;
        }
        else {
          if (!this.descarga) {
            await this.loading.dismiss();
            this.presentToast('No se encontrarón conversaciones', 'danger');
          }
        }
      },
      erro => {
        console.log(erro);
        if (!this.descarga) {
          this.loading.dismiss();
        }
      });

  }

  isPC(idAdmin) {
  const idAdminPc = ['72', '73', '74', '75', '76', '77'];

  const esPc = idAdminPc.includes(String(idAdmin));

  if (esPc) {
      this.seeFromPc = false;
  } else {
      this.seeFromPc = true;
  }
}

  resetFiltro() {
    this.tel.reset();
    this.fechaFinal.reset();
    this.fechaInicial.reset();
    this.dataFiltro = {
      estado: [],
      agente: [],
      numero: '',
      resultado: [],
      origen: [],
      equipo: []
    };
    this.arrFiltro = {
      estado: [],
      agentes: [],
      resultados: [],
      origen: [],
      equipo: []
    };
    this.totalFiltro = 0;
  }

  formatTable(conversaciones) {
    this.arrConver = conversaciones.map((conver) => ({
      // eslint-disable-next-line @typescript-eslint/naming-convention
      Telefono: conver.numero.numeroCliente,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      Nombre: conver.nombreCliente,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      'Inicio de conversación': this.formatdate.transform(conver.inicioConver, 'dd/MM/yyyy HH:mm:ss'),
      // eslint-disable-next-line @typescript-eslint/naming-convention
      'Fin de conversación': this.formatdate.transform(conver.finConversacion, 'dd/MM/yyyy HH:mm:ss'),
      // eslint-disable-next-line @typescript-eslint/naming-convention
      Agente: conver.agente,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      Resultado: conver.statusConver,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      Origen: conver.conversacion.origen,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      'No. conversación': conver.conversacion.conversacion,
      // eslint-disable-next-line quote-props
      // eslint-disable-next-line @typescript-eslint/naming-convention
      // 'Calificación': conver.calificacion.calificacion,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      // 'Otra Respuesta Calificación': conver.calificacion.otraRes,

    }));
  }

  async updatelista(lista_negra, idNum) {
    return new Promise((resolve) => {
      const data = {
        lista_negra
      };
      this.chatService.bloquearNum(data, idNum, this.idAdmin, this.classUser.id, this.classUser.rol, this.classUser.token, this.classUser.canale.url_back).subscribe((res: any) => {
        // console.log(res, 'resp bloquep')
        if (res.status == 'success') {
          if (lista_negra == 0) {
            this.presentToast('Usuario desbloqueado correctamente', 'success');
          } else {
            this.presentToast('Usuario bloqueado correctamente', 'success');
          }
          return resolve(true);
        } else {
          this.presentToast('No se pudo actualizar el número', 'danger');
          return resolve(false);
        }
      },
        err => {
          console.log(err);
          this.presentToast('No se pudo actualizar el número', 'danger');
          return resolve(false);
        })
    })
  }

  async updateBloquear(bloqueo, idNum) {
    return new Promise((resolve) => {
      const data = {
        bloqueo
      };
      this.chatService.bloquearNum(data, idNum, this.idAdmin, this.classUser.id, this.classUser.rol, this.classUser.token, this.classUser.canale.url_back).subscribe((res: any) => {
        console.log(res, 'resp bloquep')
        if (res.status == 'success') {
          if (bloqueo == 0) {
            this.presentToast('Usuario desbloqueado correctamente', 'success');
          } else {
            this.presentToast('Usuario bloqueado correctamente', 'success');
          }
          return resolve(true);
        } else {
          this.presentToast('No se pudo actualizar el número', 'danger');
          return resolve(false);
        }
      },
        err => {
          console.log(err);
          this.presentToast('No se pudo actualizar el número', 'danger');
          return resolve(false);
        })
    })
  }

  async bloquearIdFace(val, conversaciones, idface, idNum) {

    const bloq = await this.updateBloquear(val, idNum);
    console.log(bloq, 'Resp metodo bloq')

    if (bloq) {
      this.conversaciones = conversaciones.map((conver) => {

        if (conver.conversacion.numero.idFacebookMessenger == idface) {
          conver.conversacion.numero.bloqueo = val;
        }
        return conver
      });
    }
  }

  async bloquearNum(val, conversaciones, num, idNum) {
    const bloq = await this.updateBloquear(val, idNum);

    if (bloq) {
      this.conversaciones = conversaciones.map((conver) => {

        if (conver.conversacion.numero.numeroCliente == num) {
          conver.conversacion.numero.bloqueo = val;
        }
        return conver
      });
    }
  }

  async listaNegraNum(val, conversaciones, num, idNum) {
    const lista = await this.updatelista(val, idNum);

    if (lista) {
      this.conversaciones = conversaciones.map((conver) => {

        if (conver.conversacion.numero.numeroCliente == num) {
          conver.conversacion.numero.lista_negra = val;
        }
        return conver
      });
    }
  }

  busqueda(ev) {
    // console.log(ev);
    this.tel.setValue(ev.detail.value);
    if (this.tel.value) {
      if (this.tel.value.length < 6) {
        this.banderaNum = false;
      } else {
        this.banderaNum = true;
      }
      this.dataFiltro.numero = `&numero=${this.tel.value}`;
    } else {
      this.dataFiltro.numero = ``;
    }
    // console.log(this.dataFiltro.numero, this.tel.value);
  }

  menosPag() {
    // console.log(this.pagina, this.paginacion, 'menos');
    if (this.paginacion > 0) {
      this.paginacion = this.paginacion - 30;
      this.pagina = this.pagina - 1;
    }

    if (this.fechaInicial.value) {
      this.consulta(1, 0);
    } else {
      this.consulta(0, 0);
    }

    // console.log(this.pagina, this.paginacion, 'menos');
  }

  masPag() {
    // console.log(this.pagina, this.paginacion, 'mas');
    this.paginacion = this.paginacion + 30;
    this.pagina = this.pagina + 1;

    if (this.fechaInicial.value) {
      this.consulta(1, 0);
    } else {
      this.consulta(0, 0);
    }
    // console.log(this.pagina, this.paginacion, 'mas');
  }

  descargar() {
    const fechaInicioDate = new Date(this.fechaInicial.value);
    const fechaFinDate = new Date(this.fechaFinal.value);
    const MILISEGUNDOS_POR_DIA = 1000 * 60 * 60 * 24;

    const diferenciaDias = (fechaFinDate.getTime() - fechaInicioDate.getTime()) / MILISEGUNDOS_POR_DIA;

    if (diferenciaDias <= 90) {
      this.descarga = true;
      this.presentToast('Iniciando descarga', 'success');
      if (this.fechaInicial.value) {
        this.consulta(1, 0);
      } else {
        this.consulta(0, 0);
      }
      this.descarga = false;
      // this.serviceWa.exportAsExcelFile(this.arrConver, `Reporte-Conversaciones-${this.formatdate.transform(new Date(),
      //   'dd-MM-yyyy-HH-mm-ss')}`);
    } else {
      this.presentToast('No se puede realizar una descarga mayor a 3 meses', 'danger');
    }

    this.fechaFinal.reset();
    this.fechaInicial.reset();
  }

  async openMdl(conversacion, agente, cliente, nombreCliente) {
    conversacion.id_admin = conversacion.idAdmin;
    conversacion.id_agente = conversacion.idAgente;
    conversacion.id_cliente = conversacion.idCliente;
    const modal = await this.modalCtrl.create({

      component: ChatMdlPage,
      componentProps: {
        conversacion,
        agente,
        cliente,
        nombreCliente
      },
      cssClass: 'modalChats'
    });

    await modal.present();

    const { data } = await modal.onWillDismiss();
  }

  async openMdlFiltro() {
    let id;
    // if(tipo == 1) {
    //   id = this.idStatus;
    // } else if(tipo == 2) {
    //   id = this.idAgente;
    // } else {
    //   id = this.origen.value;
    // }
    const modal = await this.modalCtrl.create({

      component: MdlFiltroPage,
      componentProps: {
        dataInfo: this.classUser,
        arrFiltro: this.arrFiltro,
        reporte: 1
      },
      mode: 'ios',
      cssClass: 'modalFiltro'
    });

    await modal.present();

    const { data } = await modal.onWillDismiss();
    this.arrFiltro = data.filtro;
    if (data.filtro.agentes.length > 0) {
      this.dataFiltro.agente = data.filtro.agentes;
    } else {
      this.dataFiltro.agente = [];
    }
    if (data.filtro.resultados.length > 0) {
      this.dataFiltro.resultado = data.filtro.resultados;
    } else {
      this.dataFiltro.resultado = [];
    }
    if (data.filtro.origen.length > 0) {
      this.dataFiltro.origen = data.filtro.origen;
    } else {
      this.dataFiltro.origen = [];
    }

    if (data.filtro.equipo.length > 0) {
      this.dataFiltro.equipo = data.filtro.equipo;
    } else {
      this.dataFiltro.equipo = [];
    }

    if (data.filtro.estado.length > 0) {
      this.dataFiltro.estado = data.filtro.estado;
    } else {
      this.dataFiltro.estado = [];
    }
    this.totalFiltro = data.filtro.agentes.length + data.filtro.resultados.length + data.filtro.origen.length + data.filtro.equipo.length + data.filtro.estado.length;
    // console.log(this.arrFiltro, this.dataFiltro);
  }

  async presentLoading(mensaje) {
    this.loading = await this.loadingController.create({
      spinner: 'dots',
      //message: mensaje,
      cssClass: 'loaderGeneral',
      message: '<ion-img src="../../../assets/images/logoVabelLoading.png></ion-img>'
    });
    await this.loading.present();
  }

  busquedaReporte(ev) {
    this.searchReporte = ev.detail.value;
  }

  async presentToast(message, color) {
    const toast = await this.toastCtrl.create({
      message,
      duration: 3000,
      color
    });
    toast.present();
  }


  async mdlHistorialConversaciones(idAgente, idNumeroWhatssapp) {
    const modal = await this.modalCtrl.create({
      component: MdlBandejaAgentePage,
      cssClass: ' ModalNuecoDetallesChat animate__animated animate__fadein',
      animated: true,
      showBackdrop: false,
      backdropDismiss: false,
      componentProps: {
        //url: this.url,
        url_back: this.classUser.canale.url_back,
        idAdmin: this.idAdmin,
        classId: this.classUser.id,
        rol: this.classUser.rol,
        token: this.classUser.token,
        idAgente,
        idNumeroWhatssapp


      },
    });
    await modal.present();

  }

  calidadConversacion() {
    this.mostrarCalidad = true;
  }



  async openMdlCalidad(conversacion, agente, nombreCliente) {
    console.log(agente, nombreCliente)
    const modal = await this.modalCtrl.create({
      component: ModalCalidadPage,
      componentProps: {
        agente,
        conversacion,
        nombreCliente
      },
      cssClass: 'animate__animated animate__fadein',
      animated: true,
      showBackdrop: false,
      backdropDismiss: true,
    });
    await modal.present();

  }

  async openMdlConversacion(conversacion, agente, nombreCliente, cliente) {
    conversacion.id_admin = conversacion.idAdmin;
    conversacion.id_agente = conversacion.idAgente;
    conversacion.id_cliente = conversacion.idCliente;
    const modal = await this.modalCtrl.create({
      component: ModalConversacionPage,
      componentProps: {
        agente,
        conversacion,
        nombreCliente,
        cliente
      },
      cssClass: 'mdlConversacion animate__animated animate__fadeInLeft',
      animated: true,
      showBackdrop: false,
      backdropDismiss: true,
    });
    await modal.present();
  }
}
